module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/open/ea08618263b326f9c5020eeab67965df.png";